import { defineMessage } from 'react-intl';

import commonMessages from '~/core/commonMessages';

import { ClinchIndicator, ConferenceLabel, DivisionLabel, StandingsViewTypeLabel } from './enums';

const StandingsMessages = {
    orgLabels: {
        conference: {
            [ConferenceLabel['Clarence Campbell']]: defineMessage({
                description: 'Header denoting that user is currently viewing Clarence Campbell conference',
                defaultMessage: 'Clarence Campbell',
            }),
            [ConferenceLabel['Eastern']]: defineMessage({
                description: 'Header denoting that user is currently viewing Eastern conference',
                defaultMessage: 'Eastern',
            }),
            [ConferenceLabel['National Hockey League']]: defineMessage({
                description: 'Header denoting that user is currently viewing National Hockey League conference',
                defaultMessage: 'National Hockey League',
            }),
            [ConferenceLabel['Prince of Wales']]: defineMessage({
                description: 'Header denoting that user is currently viewing Prince of Wales conference',
                defaultMessage: 'Prince of Wales',
            }),
            [ConferenceLabel['Western']]: defineMessage({
                description: 'Header denoting that user is currently viewing Western conference',
                defaultMessage: 'Western',
            }),
            [ConferenceLabel['Wildcard']]: defineMessage({
                description: 'Header denoting that user is currently viewing Wildcard conference',
                defaultMessage: 'Wildcard',
            }),
            [ConferenceLabel['World Cup of Hockey']]: defineMessage({
                description: 'Header denoting that user is currently viewing World Cup of Hockey conference',
                defaultMessage: 'World Cup of Hockey',
            }),
            //non-ideal way of handling unexpected conference values. Will be better handled with further work on ICE-18
            default: defineMessage({
                description:
                    'Header denoting that user is currently viewing a generic conference, without the specific conference name. This is meant to act as a default value in the case the conference name cannot be found.',
                defaultMessage: 'Conference',
            }),
        },
        division: {
            [DivisionLabel['Adams']]: defineMessage({
                description: 'Header denoting that user is currently viewing Adams division',
                defaultMessage: 'Adams',
            }),
            [DivisionLabel['American']]: defineMessage({
                description: 'Header denoting that user is currently viewing American division',
                defaultMessage: 'American',
            }),
            [DivisionLabel['Atlantic']]: defineMessage({
                description: 'Header denoting that user is currently viewing Atlantic division',
                defaultMessage: 'Atlantic',
            }),
            [DivisionLabel['Canadian']]: defineMessage({
                description: 'Header denoting that user is currently viewing Canadian division',
                defaultMessage: 'Canadian',
            }),
            [DivisionLabel['Central']]: defineMessage({
                description: 'Header denoting that user is currently viewing Central division',
                defaultMessage: 'Central',
            }),
            [DivisionLabel['Discover Central']]: defineMessage({
                description: 'Header denoting that user is currently viewing Discover Central division',
                defaultMessage: 'Discover Central',
            }),
            [DivisionLabel['East']]: defineMessage({
                description: 'Header denoting that user is currently viewing East division',
                defaultMessage: 'East',
            }),
            [DivisionLabel['European']]: defineMessage({
                description: 'Header denoting that user is currently viewing European division',
                defaultMessage: 'European',
            }),
            [DivisionLabel['Group A']]: defineMessage({
                description: 'Header denoting that user is currently viewing Group A division',
                defaultMessage: 'Group A',
            }),
            [DivisionLabel['Group B']]: defineMessage({
                description: 'Header denoting that user is currently viewing Group B division',
                defaultMessage: 'Group B',
            }),
            [DivisionLabel['Honda West']]: defineMessage({
                description: 'Header denoting that user is currently viewing Honda West division',
                defaultMessage: 'Honda West',
            }),
            [DivisionLabel['MassMutual East']]: defineMessage({
                description: 'Header denoting that user is currently viewing MassMutual East division',
                defaultMessage: 'MassMutual East',
            }),
            [DivisionLabel['Metropolitan']]: defineMessage({
                description: 'Header denoting that user is currently viewing Metropolitan division',
                defaultMessage: 'Metropolitan',
            }),
            [DivisionLabel['Norris']]: defineMessage({
                description: 'Header denoting that user is currently viewing Norris division',
                defaultMessage: 'Norris',
            }),
            [DivisionLabel['North American']]: defineMessage({
                description: 'Header denoting that user is currently viewing North American division',
                defaultMessage: 'North American',
            }),
            [DivisionLabel['Northeast']]: defineMessage({
                description: 'Header denoting that user is currently viewing Northeast division',
                defaultMessage: 'Northeast',
            }),
            [DivisionLabel['Northwest']]: defineMessage({
                description: 'Header denoting that user is currently viewing Northwest division',
                defaultMessage: 'Northwest',
            }),
            [DivisionLabel['Pacific']]: defineMessage({
                description: 'Header denoting that user is currently viewing Pacific division',
                defaultMessage: 'Pacific',
            }),
            [DivisionLabel['Patrick']]: defineMessage({
                description: 'Header denoting that user is currently viewing Patrick division',
                defaultMessage: 'Patrick',
            }),
            [DivisionLabel['Scotia North']]: defineMessage({
                description: 'Header denoting that user is currently viewing Scotia North division',
                defaultMessage: 'Scotia North',
            }),
            [DivisionLabel['Smythe']]: defineMessage({
                description: 'Header denoting that user is currently viewing Smythe division',
                defaultMessage: 'Smythe',
            }),
            [DivisionLabel['Southeast']]: defineMessage({
                description: 'Header denoting that user is currently viewing Southeast division',
                defaultMessage: 'Southeast',
            }),
            [DivisionLabel['West']]: defineMessage({
                description: 'Header denoting that user is currently viewing West division',
                defaultMessage: 'West',
            }),
            [DivisionLabel['Wild Card']]: defineMessage({
                description: 'Header denoting that user is currently viewing Wild Card division',
                defaultMessage: 'Wild Card',
            }),
            //non-ideal way of handling unexpected division values. Will be better handled with further work on ICE-18
            default: defineMessage({
                description:
                    'Header denoting that user is currently viewing a generic division, without the specific division name. This is meant to act as a default value in the case the division name cannot be found.',
                defaultMessage: 'Division',
            }),
        },
    },
    table: {
        cells: {
            clinchIndicators: {
                [ClinchIndicator.conferenceClinch]: defineMessage({
                    description: 'Symbol representing the Conference clinch indicator',
                    defaultMessage: 'z',
                }),
                [ClinchIndicator.divisionClinch]: defineMessage({
                    description: 'Symbol representing the Division clinch indicator',
                    defaultMessage: 'y',
                }),
                [ClinchIndicator.playoffClinch]: defineMessage({
                    description: 'Symbol representing the Playoff spot clinch indicator',
                    defaultMessage: 'x',
                }),
                [ClinchIndicator.presidentsTrophy]: defineMessage({
                    description: "Symbol representing the Presidents' Trophy clinch indicator",
                    defaultMessage: 'p',
                }),
                [ClinchIndicator.eliminated]: defineMessage({
                    description: 'Symbol representing the team was eliminated from playoff contention',
                    defaultMessage: 'e',
                }),
            },
            clinchAriaDescriptions: {
                [ClinchIndicator.conferenceClinch]: defineMessage({
                    description: 'Denotes that the team clinched its conference',
                    defaultMessage: 'Clinched conference',
                }),
                [ClinchIndicator.divisionClinch]: defineMessage({
                    description: 'Denotes that the team clinched its division',
                    defaultMessage: 'Clinched division',
                }),
                [ClinchIndicator.playoffClinch]: defineMessage({
                    description: 'Denotes that the team clinched a Playoff spot',
                    defaultMessage: 'Clinched Playoff spot',
                }),
                [ClinchIndicator.presidentsTrophy]: defineMessage({
                    description: "Denotes that the team clinched the Presidents' Trophy",
                    defaultMessage: "Clinched Presidents' Trophy",
                }),
                [ClinchIndicator.eliminated]: defineMessage({
                    description: 'Denotes that the team was eliminated from playoff contention',
                    defaultMessage: 'Eliminated from Playoff contention',
                }),
            },
        },
        headers: {
            abbrs: {
                goalDifferential: defineMessage({
                    description:
                        'Abbreviation denoting that this is the total goal differential for this team this season. DIFF stands for Differential.',
                    defaultMessage: 'DIFF',
                }),
                goalsAgainst: defineMessage({
                    description:
                        'Abbreviation denoting that this is the total goals scored against this team this season. GA stands for Goals Against.',
                    defaultMessage: 'GA',
                }),
                goalsFor: defineMessage({
                    description:
                        'Abbreviation denoting that this is the total goals scored for this team this season. GA stands for Goals For.',
                    defaultMessage: 'GF',
                }),
                lastTen: defineMessage({
                    description:
                        'Abbreviation denoting that this is the record for the last 10 games for this team. L10 stands for Last 10 (games).',
                    defaultMessage: 'L10',
                }),
                overtime: defineMessage({
                    description:
                        'Abbreviation denoting that this is the amount of games lost in overtime this season (worth no points). OT stands for Overtime.',
                    defaultMessage: 'OT',
                }),
                points: defineMessage({
                    description:
                        'Abbreviation denoting that this is the amount of points by this team this season. PTS stands for Points.',
                    defaultMessage: 'PTS',
                }),
                pointsPercentage: defineMessage({
                    description:
                        'Abbreviation denoting that this is the points percentage by this team this season, determined by wins and losses. P% stands for Points Percentage.',
                    defaultMessage: 'P%',
                }),
                regularSeasonPointPctg: defineMessage({
                    description:
                        'Abbreviation denoting that this is the regular season points percentage for this team this season. RS P% stands for Regular Season Points Percentage.',
                    defaultMessage: 'RS P%',
                }),
                regulationWins: defineMessage({
                    description:
                        'Abbreviation denoting that this is the amount of regulation wins by this team this season. RW stands for Regulation Wins.',
                    defaultMessage: 'RW',
                }),
                regulationPlusOtWins: defineMessage({
                    description:
                        'Abbreviation denoting that this is the total wins, including OT wins, by this team this season. ROW stands for Regulation (including) Overtime Wins.',
                    defaultMessage: 'ROW',
                }),
                shootout: defineMessage({
                    description:
                        'Abbreviation denoting that this is the shootout record for this team this season. S/O stands for Shootout.',
                    defaultMessage: 'S/O',
                }),
                streak: defineMessage({
                    description:
                        'Abbreviation denoting that this is the most recent streak for this team. STRK stands for Streak.',
                    defaultMessage: 'STRK',
                }),
            },
            long: {
                away: defineMessage({
                    description: 'A phrase denoting a teams record when away',
                    defaultMessage: 'Away Record',
                }),
                clinchIndicator: defineMessage({
                    description: 'A phrase denoting whether or not a team has clinched a playoff spot',
                    defaultMessage: 'Clinch Indicator',
                }),
                goalDifferential: defineMessage({
                    description: 'A phrase denoting a teams goal differential for this season',
                    defaultMessage: 'Goal Differential',
                }),
                goalsFor: defineMessage({
                    description: 'A phrase denoting the total goals this team scored this season',
                    defaultMessage: 'Goals For',
                }),
                home: defineMessage({
                    description: 'A phrase denoting a teams record when home',
                    defaultMessage: 'Home Record',
                }),
                lastTen: defineMessage({
                    description: 'A phrase denoting a teams record for the last 10 games',
                    defaultMessage: 'Last Ten Record',
                }),
                pointsPercentage: defineMessage({
                    description: 'A phrase denoting percentage of points per game played',
                    defaultMessage: 'Point %',
                }),
                regulationWins: defineMessage({
                    description: 'A phrase denoting the amount of regulation wins by a team',
                    defaultMessage: 'Regulation Wins',
                }),
                regulationPlusOtWins: defineMessage({
                    description: 'A phrase denoting the amount of regulation and overtime wins by a team.',
                    defaultMessage: 'Regulation plus Overtime Wins',
                }),
                shootout: defineMessage({
                    description: 'A phrase denoting a teams record in shootouts',
                    defaultMessage: 'Shootout Record',
                }),
                streak: defineMessage({
                    description: 'A phrase denoting a teams streak. W5 - 5 wins in a row',
                    defaultMessage: 'Streak',
                }),
            },
            away: commonMessages.gameLocationDescriptions.short.away,
            home: commonMessages.gameLocationDescriptions.short.home,
            team: defineMessage({
                description: 'Denotes that this is the team to which the data pertains.',
                defaultMessage: 'Team',
            }),
        },
    },
    viewToggleOptions: {
        [StandingsViewTypeLabel.conference]: defineMessage({
            description: 'Denotes that the toggler panel will switch Standings to Conference view if selected',
            defaultMessage: 'Conference',
        }),
        [StandingsViewTypeLabel.division]: defineMessage({
            description: 'Denotes that the toggler panel will switch Standings to Division view if selected',
            defaultMessage: 'Division',
        }),
        [StandingsViewTypeLabel.league]: defineMessage({
            description: 'Denotes that the toggler panel will switch Standings to League view if selected',
            defaultMessage: 'League',
        }),
        [StandingsViewTypeLabel.wildcard]: defineMessage({
            description: 'Denotes that the toggler panel will switch Standings to Wildcard view if selected',
            defaultMessage: 'Wild Card',
        }),
    },
};

export default StandingsMessages;
